module.exports = __webpack_public_path__ + "img/user-face-1.bc161d8d.jpg";